import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import { FcExpired } from 'react-icons/fc';

export const SessionLostContainer = () => {
  return (
    <div className="pageContainer">
      <Row gutter={[8, 8]} style={{ backgroundColor: '#ffffff' }}>
        <Col flex={2}>
          <FcExpired style={{ fontSize: '6em', color: '#FFC000', textAlign: 'center' }} />
        </Col>
        <Col flex={3}>
          <Typography.Title level={2}>Session expired</Typography.Title>
          <p className="oidc-authenticating__content">
            Your session has expired. Please re-authenticate.{' '}
          </p>
          <a href="/">
            <Button type="primary">Login</Button>
          </a>
        </Col>
      </Row>
    </div>
  );
};

export default SessionLostContainer;
